module.exports = __webpack_public_path__ + "img/Feature.7840b8ef.png";